import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTenant } from './useTenant';
import ContextualLoginPage from './ContextualLoginPage';
import { Loader2 } from 'lucide-react';
import { getJobLoginContextOptions } from '@/api/query';

interface LoginWithJobContextProps {
  jobId: string;
}

const LoginWithJobContext: React.FC<LoginWithJobContextProps> = ({ jobId }) => {
  const tenant = useTenant();
  const { data: job, isLoading } = useQuery({
    ...getJobLoginContextOptions({ query: { job_id: parseInt(jobId, 10) } }),
    enabled: !!jobId,
    retry: false,
  });

  const displayName = tenant.name || 'Recruit41';

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-background flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" />
          <p className="text-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (!job) {
    return (
      <ContextualLoginPage
        contextDescription={`You're signing in to apply for a job at ${displayName}.`}
        jobTitle="..."
      />
    );
  }

  const isAssessment = Boolean(job.assessment_enabled);
  return (
    <ContextualLoginPage
      contextDescription={
        isAssessment
          ? `You're signing in to take the ${job.title} assessment at ${displayName}.`
          : `You're signing in to apply for ${job.title} at ${displayName}.`
      }
      jobTitle={job.title}
      isAssessment={isAssessment}
    />
  );
};

export default LoginWithJobContext;
